import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Encoding, GetEnumValuesDto, SmsCp, StatisticsSendStatus } from 'src/app/core/api/models';
import { OperatorTypesUi } from 'src/app/configs/operator-type-ui.config';
import { SendStatusTypesUi } from 'src/app/configs/status-type-ui.config';
import { SendEncodingTypesUi } from 'src/app/configs/encoding-type-ui.config';

@Component({
    selector: 'app-doughnut-chart-operators-sending',
    templateUrl: './doughnut-chart-operators-sending.component.html',
    standalone: false
})
export class DoughnutChartOperatorsSendingComponent implements OnInit {

  @Input() model: any[] = [];
  @Input() chartId: string = '';
  @Input() statisticsPropName: string = "smsEncoding";
  @Input() SmsCpEnumValues: GetEnumValuesDto[];
  @Input() StatisticsSendStatusEnumValues: GetEnumValuesDto[];

  labels: string[] = [];
  colors: string[] = [];
  data: number[] = [];
  title:string= this.translateService.instant('pages.statisticalReports.doughnutChartDescription');

  get Encoding() { return Encoding };
  get SmsCp() { return SmsCp };
  get StatisticsSendStatus() { return StatisticsSendStatus };
  constructor(private translateService: TranslateService) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes["model"] || changes["StatisticsSendStatusEnumValues"] || changes["SmsCpEnumValues"])) {
      if (this.model?.length && (this.SmsCpEnumValues?.length || this.StatisticsSendStatusEnumValues?.length || this.statisticsPropName == "smsEncoding" || this.statisticsPropName == "smsCp")) {
        this.setData();
      }
    }
  }

  setData() {
    let labels2 = [];
    let colors2 = [];
    let data2 = [];
    switch (this.statisticsPropName) {
      case 'smsEncoding':
        function smsEncoding_getKeyByValue(value: string) {
          const indexOfS = Object.values(Encoding).indexOf(value as unknown as Encoding);
          const key = Object.keys(Encoding)[indexOfS];
          return key;
        }
        this.model.filter(a => a.count > 0).forEach(item => {
          labels2.push(this.translateService.instant('enums.Encoding.' + smsEncoding_getKeyByValue(item.type)));
          colors2.push(SendEncodingTypesUi.find(a => a.type.toString() == item.type)?.color);
          data2.push(item?.count);
        });
        this.labels = labels2;
        this.colors = colors2;
        this.data = data2;
        break;
      case 'statisticsSendStatus':
        this.model.filter(a => a.count > 0).forEach(item => {
          labels2.push(this.StatisticsSendStatusEnumValues.find(a => a.key == item.type)?.value);
          if(SendStatusTypesUi.find(a => a.type.toString() == item.type)?.color)
          colors2.push(SendStatusTypesUi.find(a => a.type.toString() == item.type)?.color);
          data2.push(item?.count);
        });
        this.labels = labels2;
        this.colors = colors2;
        this.data = data2;
        break;
      case 'cpType':
        this.model.filter(a => a.count > 0).forEach(item => {
          labels2.push(this.SmsCpEnumValues.find(a => a.key == item.type)?.value);
          colors2.push(OperatorTypesUi.find(a => a.type.toString() == item.type)?.color);
          data2.push(item?.count);
        });
        this.labels = labels2;
        this.colors = colors2;
        this.data = data2;
        break;
      case 'smsCp':
        let counter = 0;
        this.model.filter(a => a.count > 0).forEach(item => {
          labels2.push(item.type);
          colors2.push(OperatorTypesUi[counter].color);
          data2.push(item.count);
          counter++;
        });
        this.labels = labels2;
        this.colors = colors2;
        this.data = data2;
        break;
    }
  }
}
